import { Add as AddIcon } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import CustomDataGrid from "components/common/CustomDataGrid";
import { EDefaultValues } from "constants/defaultValues";
import { BranchDto } from "libs/cellera-sdk";
import { useMemo } from "react";
import { useCelleraTheme } from "theme/useCelleraTheme";
import { v4 as uuidv4 } from "uuid";
interface BranchesSectionProps {
  branches: BranchDto[];
  minHeight?: number;
  rowsPosition?: "absolute" | "relative";
  onAddBranch?: () => void;
}

function BranchesSection({
  branches,
  minHeight = 150,
  rowsPosition = "absolute",
  onAddBranch,
}: BranchesSectionProps) {
  const isAddBranch = useMemo(() => !!onAddBranch, [onAddBranch]);
  const { colors } = useCelleraTheme();
  const columns: GridColDef<BranchDto>[] = [
    {
      field: "address",
      headerName: "Address",
      flex: 1,
      renderCell: (params) => {
        return params.value || EDefaultValues.EMPTY_STRING;
      },
    },
    {
      field: "emailAddress",
      headerName: "Email Address",
      flex: 1,
      renderCell: (params) => {
        return params.value || EDefaultValues.EMPTY_STRING;
      },
    },
    {
      field: "primaryPhoneNumber",
      headerName: "Primary Phone Number",
      flex: 1,
      renderCell: (params) => {
        return params.value || EDefaultValues.EMPTY_STRING;
      },
    },
    {
      field: "faxNumber",
      headerName: "Fax Number",
      flex: 1,
      renderCell: (params) => {
        return params.value || EDefaultValues.EMPTY_STRING;
      },
    },
  ];

  const rows = branches.map((branch) => ({
    id: uuidv4(),
    address: branch.address,
    emailAddress: branch.emailAddress,
    primaryPhoneNumber: branch.primaryPhoneNumber,
    faxNumber: branch.faxNumber,
  }));

  return (
    <Box className="space-y-6 mt-8">
      <Box
        component="div"
        className="flex flex-row justify-between items-center"
      >
        <Typography variant="h6" className="text-xl font-medium">
          Branches
        </Typography>
        {isAddBranch && (
          <Button
            className="py-0 px-3 rounded-full"
            startIcon={<AddIcon />}
            sx={{
              backgroundColor: colors.background.default,
              color: colors.text.navyDark,
              border: `1px solid ${colors.text.navyDark}`,
            }}
            onClick={onAddBranch}
          >
            Select
          </Button>
        )}
      </Box>
      <CustomDataGrid
        rows={rows}
        columns={columns}
        minHeight={minHeight}
        rowsPosition={rowsPosition}
      />
    </Box>
  );
}

export default BranchesSection;
